export const API_KEY = "b44bddfd870fac89b4b04cc795f91582";
export const TMDB_BASE_URL = 'https://api.themoviedb.org/3';